import React, { Component } from 'react'
import TopNav from '../../components/topnav/topnav';
import ManageUserPlan from '../../components/manageuserplan/manageuserplan';
import { connect } from 'react-redux';
import { changePlan, deleteUser } from "../../../../core/actions/auth"
import { getUser } from '../../../../core/actions/allUsers';
import moment from 'moment'
import Axios from 'axios';
import { domainURL, CLOUD_FUNCTION } from "../../../../../config/fbConfig"
// import Footer from '../../components/footer/footer';
import { Row, Col, Typography, Tag, Divider, Collapse, Select, Button, Icon, Card, Modal, Spin, Popconfirm } from 'antd';
import { bindActionCreators } from 'redux';
const { Title } = Typography;
const Panel = Collapse.Panel;
const Option = Select.Option;
const confirm = Modal.confirm;

class ManageUser extends Component {
  constructor(props) {
    super(props)

    this.state = {
      user: {}
    }
  }

  componentDidMount() {
    const { slug } = this.props.match.params
    this.props.getUser(slug)
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.localAuth.changePlanSuccess) {
      this.props.getUser(nextProps.match.params.slug)
    }
    const { user } = nextProps;
    if (user) {
      this.setState({
        user
      })
    }
  }

  performDelete = () => {
    const { user } = this.state
    Axios.post(`${CLOUD_FUNCTION}/api/deleteUser`, { userID: user.uid })
      .then((res) => {
        if (res.data.success) {
          console.log(res.data)
        } else {
          console.log(res.data)
        }
      }).catch((err) => console.log(err))

    this.props.deleteUser(user.uid)
    this.props.history.push('/settings')
  }

  render() {
    const { localAuth, changePlan } = this.props
    const { user } = this.state
    const text = 'Are you sure to delete this user?'
    return (
      <div>
        <TopNav history={this.props.history} />
        <section className="manageuser-page">
          <div className="heading-holder">
            <h2 className="heading">Manage User</h2>
            <Popconfirm placement="topRight" title={text} onConfirm={this.performDelete} okText="Yes" cancelText="No">
              <Button type="danger">Delete User <Icon type="delete" />
              </Button>
            </Popconfirm>
          </div>
          <Divider />
          <Row gutter={16} className="profile-holder">
            <Col lg={12} sm={24} className="profile-main">
              <Row>
                <Col lg={8} md={6} sm={12}>
                  <img src="/img/user.png" alt="" className="profile-img" />
                </Col>
                <Col lg={16} md={18} sm={12}>
                  <div className="profile-details">
                    <h2 className="profile-name">{user.fullName}</h2>
                    <span>
                      <span className="bold-span">Email:</span> {user.email}
                    </span>

                    <span> <span className="bold-span">Date Joined:</span> 10/30/1999</span>

                    <span className="role-plan"> <span className="bold-span">Role:</span> {user.role}</span>

                    {user.plan ? <span className="role-plan"> <span className="bold-span">Plan:</span> {user.plan}</span> : null
                    }
                  </div>
                </Col>
              </Row>
            </Col>
            <Col lg={{ span: 10, offset: 2 }} sm={24} className="profile-actions">
              <Card title="Manage User Plan">
                <div className="panel-content">
                  {user.fullName} is currently on <Tag color="blue"> {user.plan}</Tag>
                  {user.plan !== 'free' ?
                    <span>plan that ends on <br />{moment.unix(user.current_period_end).format('ll')}</span> : null
                  }
                  <hr />
                  <ManageUserPlan user={user} auth={localAuth} changePlan={changePlan} />
                </div>
              </Card>
              <Divider />
            </Col>
          </Row>
        </section>
      </div>
    )
  }
}

const mapStateToProps = (state) => ({
  user: state.allUsers.user,
  localAuth: state.auth
})

const mapDispatchToProps = dispatch => bindActionCreators({
  changePlan,
  getUser,
  deleteUser
}, dispatch)

// const mapDispatchToProps = dispatch => ({
//   getUser: (userId) => dispatch(getUser(userId)),
//   changePlan
// });

export default connect(mapStateToProps, mapDispatchToProps)(ManageUser)